import * as React from "react";

export default function SettingsPage() {
  return (
    <h1>helloSettingsPage</h1>
  );
}